/*
 * The scripts, bundled by Vite (see vite.config.js). Most of the libraries are jQuery plugins that expect jQuery as
 * a global, which ./jquery.js sets before they are evaluated (imports are evaluated in order).
 */

// cookie consent
import 'cookieconsent/src/cookieconsent.js';

// jquery
import $ from './jquery.js';

// jquery validation
import 'jquery-validation';

// loading attribute polyfill
import 'loading-attribute-polyfill';

// slick-carousel
import slick from 'slick-carousel';

// our code
import './cookies.js';
import './mobile.js';
import './sidebar.js';
import './testimonials.js';

// slick-carousel's CommonJS build exports a function that registers the plugin, rather than registering it.
slick(window, $);
